import { type FC, useEffect } from 'react';

import RHBIcon from '@/assets/icons/rhb-start-icon.svg?react';
import { SPLASH_SCREEN_ANIMATION_DURATION } from '@/utils/constants';

interface StartViewProps {
  onFinish: () => void;
}

const StartView: FC<StartViewProps> = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, SPLASH_SCREEN_ANIMATION_DURATION);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="w-full h-dvh grid place-items-center">
      <div className="overflow-hidden w-[258px] h-5 relative">
        <RHBIcon className="absolute left-0 top-0 h-full text-white animate-rhb-icon-reveal" />
      </div>
    </div>
  );
};

export default StartView;
